/**
 * Swing MenuNode.getCountString() parity: "(3)" or "(3/7)" when any count > 0.
 */
export function formatMenuCountString(counts: number[] | undefined): string {
  if (!counts?.length) return ''

  let hasPositive = false
  for (const cnt of counts) {
    if (cnt > 0) {
      hasPositive = true
      break
    }
  }
  if (!hasPositive) return ''

  return `(${counts.join('/')})`
}

/** Swing MenuModel `<count>`: comma-separated Long values. */
export function parseMenuCountValue(raw: string | undefined): number[] | undefined {
  if (!raw?.trim()) return undefined
  try {
    const parts = raw.split(',').map((s) => Number(s.trim()))
    if (parts.some((n) => Number.isNaN(n))) return undefined
    return parts
  } catch {
    return undefined
  }
}
